import React, { Component } from "react";
// import firebase from "firebase";
// import { firebase_config } from "../../constants/ActionTypes";

export default class LoginController extends Component {
  constructor(props) {
    super(props);
    this.state = {
      redirect: false,
      page: "",
    };
  }

  componentDidMount() {
    console.log("token", this.props.login.token);

    // if (localStorage.getItem("token") !== null) {
    //   this.props.fetchToken(localStorage.getItem("token"));
    // }
  }

  render() {
    return <div />;
  }
}
